/**
 * ConfirmPasswordConfirmation.jsx
 * Created by michaelbray on 2/13/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import * as Icons from '../../../sharedComponents/icons/Icons';
import { FlexCol, FlexRow } from '../../../sharedComponents/FlexGrid';
import Button from '../../../sharedComponents/Button';
import Heading from '../../../sharedComponents/Heading';

const propTypes = {
    label: PropTypes.string,
    message: PropTypes.string,
    email: PropTypes.string,
    closeModal: PropTypes.func
};

export default class ConfirmPasswordConfirmation extends React.Component {
    componentDidMount() {
        this.header.focus();
    }

    render() {
        return (
            <FlexRow justifyContent="center">
                <FlexCol sm={8} className="rec-acct-modal-confirm-password-confirmation-body">
                    <div ref={(header) => this.header = header} tabIndex="-1" className="rec-hide-focus">
                        <Heading
                            headingLevel={1}
                            appearance="display"
                            className="rec-acct-modal-title"
                            id="confirmPasswordModalHeading">
                            {this.props.label}
                        </Heading>
                    </div>
                    <div className="rec-acct-modal-media">
                        <Icons.IconCheck />
                    </div>
                    <p>{this.props.message}</p>
                    <p><strong>{this.props.email}</strong></p>
                    <Button
                        size="lg"
                        onClick={this.props.closeModal}
                        title="Close"
                        aria-label="Close">
                        Close
                    </Button>
                </FlexCol>
            </FlexRow>
        );
    }
}

ConfirmPasswordConfirmation.propTypes = propTypes;
